import close from '../../../images/newDesign/close.svg';
import { RewardDetailsPopUp as PopUp } from "./RewardDetailsPopUp.styled";
import Button from "../../../common/Button";
import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import Input from "../../../common/simple/input";
import { Form, Formik } from "formik";
import BllinkUtils from "../../../common/utils/utils";
import * as yup from "yup";
import CacheData from "../../../common/utils/cacheData";
import { useSelector } from "react-redux";

export default function RewardDetailsPopUp({show, setShow, collectPrize, textOverrides = {}}) {
    const {t} = useTranslation();
    const savedRewardDetails = CacheData.fetchCache('rewardDetails');
    const ltr = useSelector(state => state.common.ltrEnabled);

    const initialFormValues = {
        phone: savedRewardDetails?.phone || '',
        email: savedRewardDetails?.email || '',
        fullName: savedRewardDetails?.fullName || '',
        apartment: '',
        street: '',
        city: '',
    };

    const validationSchema = yup.object().shape({
        phone: yup.string().required(t('titles.forms.mandatory_field'))
            .test('phone-validation', t('titles.forms.correct_phone'),
                value => value ? BllinkUtils.JsExtras.phoneValidator(
                    null, value, {minLength: 9, maxLength: 10}
                ) : false
            ),
        email: yup.string().required(t('titles.forms.mandatory_field'))
            .test('phone-validation', t('titles.forms.correct_email'),
                value => BllinkUtils.JsExtras.emailValidator(value)
            ),
        fullName: yup.string().min(2, t('titles.forms.min_string_size', {'size': 2}))
            .required(t('titles.forms.mandatory_field')),
    });

    const submitForm = (values, resetForm) => {
        collectPrize(values).then((result) => {
            if (result) {
                CacheData.cache('rewardDetails', values);
                closePopUp();
                resetForm();
            }
        });
    }

    const closePopUp = () => {
        setShow(false);
    };

    return (
        <PopUp
            className="header-with-bg"
            show={show}
            onHide={closePopUp}
            ltr={ltr}
        >
      <span onClick={closePopUp} className="modal-close">
        <img src={close} alt="close"/>
      </span>
            <PopUp.Header className="text-center">
                {textOverrides.detailsPopUpTitle || t('payment_settings.fillDetailsToCollectPrize')}
            </PopUp.Header>
            <PopUp.Body>
                <Formik
                    initialValues={initialFormValues}
                    validationSchema={validationSchema}
                    onSubmit={(values, actions) => submitForm(values, actions.resetForm)}
                >
                    {({
                          errors,
                          touched,
                          values,
                          handleChange,
                          handleBlur,
                          isValid,
                          dirty,
                      }) => (
                        <Form className={'form'}>
                            <div dir={ltr}>
                                <div className={'section'}>
                                    <span className={'section-title'}>{t('manager_rewards.personal_details')}</span>
                                    <Row className={'upper-row'}>
                                        <Col>
                                            <Input
                                                label={t('manager_rewards.full_name')}
                                                type="text"
                                                className="form-control"
                                                name="fullName"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.fullName}
                                            />
                                            {
                                                errors.fullName && touched.fullName && (
                                                    <label className={'error'}>{errors.fullName}</label>
                                                )
                                            }
                                        </Col>
                                        <Col>
                                            <Input
                                                label={t('manager_rewards.email')}
                                                type="email"
                                                className="form-control"
                                                name="email"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.email}
                                            />
                                            {
                                                errors.email && touched.email && (
                                                    <label className={'error'}>{errors.email}</label>
                                                )
                                            }
                                        </Col>
                                        <Col>
                                            <Input
                                                label={t('manager_rewards.phone')}
                                                type="text"
                                                className="form-control"
                                                name="phone"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.phone}
                                            />
                                            {
                                                errors.phone && touched.phone && (
                                                    <label className={'error'}>{errors.phone}</label>
                                                )
                                            }
                                        </Col>
                                    </Row>
                                </div>
                                <div className={'section lower-section'}>
                                    <span className={'section-title'}>{t('manager_rewards.delivery_details')}</span>
                                    <Row className={'lower-row'}>
                                        <Col>
                                            <Input
                                                label={t('manager_rewards.city')}
                                                type="text"
                                                className="form-control"
                                                name="city"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.city}
                                            />
                                        </Col>
                                        <Col>
                                            <Input
                                                label={t('manager_rewards.street_and_num')}
                                                type="text"
                                                className="form-control"
                                                name="street"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.street}
                                            />
                                        </Col>
                                        <Col>
                                            <Input
                                                label={t('manager_rewards.apartment')}
                                                type="text"
                                                className="form-control"
                                                name="apartment"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.apartment}
                                            />
                                        </Col>
                                    </Row>
                                </div>

                                {textOverrides.detailsPopUpExplainText &&
                                    <span className={'button-explain'}>{textOverrides.detailsPopUpExplainText}</span>
                                }
                                <Button type="submit" className="modal-button" rounded={true}
                                        disabled={!(isValid && dirty)}
                                >{textOverrides.detailsPopUpConfirm || t('manager_rewards.collect')}</Button>

                            </div>
                        </Form>
                    )}
                </Formik>
            </PopUp.Body>
        </PopUp>
    )
}
